export enum UserType {
  DRIVER = 'driver',
  MERCHANT = 'merchant',
  EMPLOYEE = 'employee',
  ORGANISATION = 'organisation',
}
